<template>
    <div :class="cardClass">
      <slot name="content"></slot>
    </div>
</template>

<script>
export default {
  props: {
    cardClass : {
      type: String,
      default : 'bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 p-3 rounded-md' 
    }
  }
};
</script>
